var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.297,
    height: 15.962,
    viewBox: "0 0 18.297 15.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#242424;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M542.85,479.238a1.233,1.233,0,0,1,.807.3l1.156,1a.5.5,0,0,1,.479-.355h3.826a.684.684,0,0,1,.683.683v3.991l1.808,1.566a.683.683,0,0,1-.447,1.2h-1.14V494.7a.5.5,0,0,1-.5.5h-4.009a.5.5,0,0,1-.5-.5v-7.076h-4.238V494.7a.5.5,0,0,1-.5.5h-4.009a.5.5,0,0,1-.5-.5v-7.076h-1.718a.5.5,0,0,1-.327-.878l8.322-7.208A1.232,1.232,0,0,1,542.85,479.238Zm2.442,2.878a.5.5,0,0,1-.327-.122l-1.962-1.7a.233.233,0,0,0-.152-.057.229.229,0,0,0-.152.057l-7.309,6.33h.877a.5.5,0,0,1,.5.5V494.2h3.009v-7.076a.5.5,0,0,1,.5-.5h5.238a.5.5,0,0,1,.5.5V494.2h3.009v-7.076a.5.5,0,0,1,.5-.5h.79l-1.339-1.159a.5.5,0,0,1-.173-.378v-3.9h-3.009v.431a.5.5,0,0,1-.5.5Z",
    transform: "translate(-533.548 -479.238)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1b68a8702d20fa374967c62d1aabb276.svg";
export { ForwardRef as ReactComponent };